import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

import { useTheme } from '@mui/material/styles';
import { Box, Chip, Divider, Grid, Stack, Tab, Tabs, Typography } from '@mui/material';

import MainCard from '../../Components/MainCard';
import SubscribingInfo from "../../sections/apps/getting-started/SubscribingInfo";
import DashboardInfo from "../../sections/apps/getting-started/DashboardInfo";
import XeroOrganisations from "../../sections/apps/getting-started/XeroOrganisations";
import UserAddOns from "../../sections/apps/getting-started/UserAddOns";
import FAQInfo from "../../sections/apps/getting-started/FAQInfo";

function TabPanel({ children, value, index, ...other }) {
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`getting-started-tabpanel-${index}`}
      aria-labelledby={`getting-started-tab-${index}`}
      {...other}
    >
      {value === index && <Box>{children}</Box>}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired
};

function a11yProps(index) {
  return {
    id: `getting-started-tab-${index}`,
    'aria-controls': `getting-started-tabpanel-${index}`
  };
}

const GettingStarted = () => {
    const theme = useTheme();
    const [value, setValue] = useState(0);
    const handleChange = (event, newValue) => {
        setValue(newValue);
      };



    return (
        <>
            <Grid container spacing={2} xs={12} alignItems="center" justifyContent="center" sx={{ mt: { md: 15, xs: 2.5 }, mb: { md: 10, xs: 2.5 } }}>
                <Grid item xs={12} md={7} xl={8}>
                    <MainCard>
                        <Stack spacing={3}>
                            <Stack>
                                <Tabs
                                    value={value}
                                    indicatorColor="primary"
                                    onChange={handleChange}
                                    aria-label="Getting Started tabs"
                                    variant="scrollable"
                                  >
                                    <Tab label="Subscribing" {...a11yProps(0)} />
                                    <Tab label="Dashboard Analytics" {...a11yProps(1)} />
                                    <Tab label="Xero Organisations" {...a11yProps(2)} />
                                    <Tab label="User Add Ons" {...a11yProps(3)} />
                                    <Tab label="FAQ" {...a11yProps(4)} />
                                </Tabs>
                                <Divider />
                            </Stack>
                            <TabPanel value={value} index={0}>
                                <SubscribingInfo />
                            </TabPanel>
                            <TabPanel value={value} index={1}>
                                <DashboardInfo />
                            </TabPanel>
                            <TabPanel value={value} index={2}>
                                <XeroOrganisations />
                            </TabPanel>
                            <TabPanel value={value} index={3}>
                                <UserAddOns />
                            </TabPanel>
                            <TabPanel value={value} index={4}>
                                <FAQInfo />
                            </TabPanel>
                        </Stack>
                    </MainCard>
                </Grid>
            </Grid>

        </>
    )

}

export default GettingStarted;